export class CreateLivestreamButtonComponent {
    entry!: string;
    entryId!: number;
    meetingId!: number;

    constructor(protected $uibModal: any) {}

    open() {
        this.$uibModal.open({
            animation: true,
            component: 'tyLivestreamWizard',
            windowClass: 'livestream_wizard_modal',
            windowTopClass: 'livestream_wizard_modal',
            resolve: {
                meetingId: () => this.meetingId,
                entry: () => ({ entry_id: this.entryId, entry: this.entry }),
            },
        });
    }
}

angular.module('tradersyard').component('tyCreateLivestreamButton', {
    // language=HTML
    template: `
        <button class="btn btn-wide btn-red" ng-click="$ctrl.open()">
            <i class="fa fa-broadcast-tower"></i> Start Live stream
        </button>
    `,
    controller: CreateLivestreamButtonComponent,
    bindings: {
        entry: '@',
        entryId: '<',
        meetingId: '@',
    },
});
